import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Section1 from "@/pages/sections/section1";
import Section2 from "@/pages/sections/section2";
import Section3 from "@/pages/sections/section3";
import Hero from "@/layout/hero";

const HomePage: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    // Si l'URL contient un hash, scroller vers la section correspondante
    if (router.asPath.includes('#')) {
      const hash = router.asPath.split('#')[1];
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [router.asPath]);

  return (
    <>
      <Hero />
      <main id="main-content">
        <Section1 />
        <Section2 />
        <Section3 />
      </main>
    </>
  );
};

export default HomePage;
